import { DialogBody } from "@blueprintjs/core";
import React from "react";

import { Button } from "../Button/button";
import { Modal } from "../modal/modal";
import styles from "./delete-series-modal.module.css";

export interface DeleteSeriesModalProps {
  show: boolean;
  handleClose: (e: any) => void;
  SeriesName: string;
  handleDeleteSeries: (e: any) => void;
}

export const DeleteSeriesModal = ({ show, handleClose, SeriesName, handleDeleteSeries }: DeleteSeriesModalProps) => {
  return (
    <Modal
      title="Delete Series"
      isOpen={show}
      onClose={handleClose}
      actions={[
        <Button minimal={true} text="Cancel" onClick={handleClose} key={2} />,
        <Button intent="danger" text="Delete" onClick={handleDeleteSeries} key={1} />,
      ]}
    >
      <DialogBody>
        <div>
          Are you sure you want to delete Series <div className={styles.seriesName}>{SeriesName}</div>?
        </div>
      </DialogBody>
    </Modal>
  );
};
